var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('c-table',{attrs:{"table-data":_vm.result,"loading":_vm.loading,"fields":_vm.fields,"striped":true,"export-enabled":false,"tableName":"auditTable"},on:{"onPageIndexChanged":_vm.onPageIndexChanged}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }